const toolNames = {
  ANONYMIZE: 'Anonymize',
  WWWC: 'Wwwc',
  WL_PRESETS: 'WLPresets',
  WL_PRESET: 'WLPreset',
  INFINITE_SCROLL: 'InfiniteScroll',
  WWWC_INPUT: 'WwwcInput',
  LANGUAGE: 'Language',
  RESET: 'Reset',
  HISTORY: 'History',
  GROUPED_TOOLS: 'GroupedTools',
  ZOOM: 'Zoom',
  ZOOM_MENU: 'ZoomMenu',
  ZOOM_1_TO_1: 'Zoom1To1',
  ZOOM_FIT: 'ZoomFit',
  ZOOM_ACTUAL_SIZE: 'ZoomActualSize',
  PAN: 'Pan',
  LAYOUT: 'Layout',
  INVERT: 'Invert',
  ROTATE_MENU: 'RotateMenu',
  ROTATE90: 'Rotate90',
  ROTATE270: 'Rotate270',
  HFLIP: 'HFlip',
  VFLIP: 'VFlip',
  RESET_POSITION: 'ResetPosition',
  MAGNIFY_PLUS: 'MagnifyPlus',
  CINE: 'Cine',
  REF_LINES: 'RefLines',
  ANNOTATIONS: 'annotations',
  LENGTH: 'Length',
  ANGLE: 'Angle',
  COBB_ANGLE: 'CobbAngle',
  RECTANGLE_ROI: 'RectangleRoi',
  ELLIPTICAL_ROI: 'EllipticalRoi',
  FREEHAND_ROI: 'FreehandRoi',
  ERASER: 'Eraser',
  CLEAR_ANNOTATIONS: 'ClearAnnotations',
  SCREENSHOT: 'screenshot',
  COPY_CAPTURE: 'copyCapture',
  DOWNLOAD_CAPTURE: 'downloadCapture',
  MODE_3D: '3D',

  ROTATE: 'Rotate',
  CLIPPING: 'clipping',
  PALETTES_VR: 'palettesVR',
  PALETTE_VR: 'paletteVR',
  PALETTES: 'palettes',
  GREYSCALE: 'greyScale',
  BONEPALETTE: 'bonePalette',
  AIRBONEPALETTE: 'airBonePalette',
  AIRPALETTE: 'airPalette',
  REDPALETTE: 'redPalette',
  FIREPALETTE: 'firePalette',
  ICEPALETTE: 'icePalette',
  RAINBOWPALETTE: 'rainBowPalette',
  INTENSITY: 'intensity',
  INTENSITY_PROJECTION: 'intensityProjection',
  THICKNESS: 'thickness',
  MODE_2D: '2D',
  MODE_MPR: 'MPR',
  CROSS_REFERENCE: 'CrossReference',
  DECREASE_SECONDS: 'decreaseSeconds',
  INCREASE_SECONDS: 'increaseSeconds',
  INCREASE_VOLTAGE: 'increaseVoltage',
  DECREASE_VOLTAGE: 'decreaseVoltage',

  LAYOUT_ECG_GENERAL: 'LayoutEcgGeneral',
  LAYOUT_ECG_12: 'LayoutEcg12',
  LAYOUT_ECG_ALL: 'LayoutEcgAll',
  LAYOUT_ECG: 'LayoutEcg',
  HANGING_PROTOCOLS: 'HangingProtocols',
};

export default toolNames;
